export default {
    usersIndex: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/users',
    },
    usersIndexDeleted: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/users/deleted',
    },
    userView: {
        method: 'GET',
        url: process.env.VUE_APP_API_URL + '/user/:id'
    },
    userUpdate: {
        method: 'PUT',
        url: process.env.VUE_APP_API_URL + '/user/:id'
    },
    deleteUser: {
        method: 'GET',
        url: process.env.VUE_APP_API_URL + '/user/delete/:userId'
    },
    changeActiveUser: {
        method: 'GET',
        url: process.env.VUE_APP_API_URL + '/user/in-active/:userId'
    },
    restoreUser: {
        method: 'GET',
        url: process.env.VUE_APP_API_URL + '/user/restore/:userId'
    },
}